/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, mediaQuery,  } from 'utils/styles';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// QUESTION STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
	question: {
		// borderBottom: '1px solid #fff',
		height: hasRewardsComponent => hasRewardsComponent ? '30%' : '35%',
        // marginBottom: pxToEm(5),
        '&.text-2, &.text-3': {
            height: hasRewardsComponent => hasRewardsComponent ? '35%' : '40%',
        },
        '&.text-2, &.text-3, &.text-4': {
            '&.extended-large': {
                marginBottom: pxToEm(10)
            },
            '&.extended-small': {
                marginBottom: pxToEm(6)
            },
        },
        '&.large-true': {
            fontSize: '115%'
        },

		'& .text': {
			// 24 chars per line at 22px fontsize
			// 56 is limit for 3 lines at 22px fontsize
			fontSize: pxToEm(18),
			lineHeight: '1.1',
			paddingTop: hasRewardsComponent => pxToEm(hasRewardsComponent ? 10 : 15),
            '&.medium': { fontSize: pxToEm(17), lineHeight: '1.15' },
			'&.small': { fontSize: pxToEm(16), lineHeight: '1.15' },
			'&.xsmall': { fontSize: pxToEm(15), lineHeight: '1.15' },
			'&.xxsmall': { fontSize: pxToEm(13.5), lineHeight: '1.25', paddingTop: '0' },
			'&.xxxsmall': { fontSize: pxToEm(12.5), lineHeight: '1.25', paddingTop: '0' },
			'&.x4small': { fontSize: pxToEm(11.5), lineHeight: '1.25', paddingTop: '0' },
			'&.x5small': { fontSize: pxToEm(10.5), lineHeight: '1.25', paddingTop: '0' },
			'&.x6small': { fontSize: pxToEm(9.5), lineHeight: '1.25', paddingTop: '0' },
			'&.x7small': { fontSize: pxToEm(8.5), lineHeight: '1.25', paddingTop: '0' },
			'&.x8small': { fontSize: pxToEm(8), lineHeight: '1.25', paddingTop: '0' }
		}
	},
	// ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
	// [mediaQuery.thin]: {
	// 	// question: { '& .text': { fontSize: pxToEm(18) } }
	// 	question: { fontSize: '90%' }
	// },
    // [mediaQuery.wide]: {
    //     // question: { '& .text': { fontSize: pxToEm(18) } }
    //     question: { fontSize: '135%' }
    // },
    // [mediaQuery.medium]: {
    //     // question: { '& .text': { fontSize: pxToEm(18) } }
    //     question: { fontSize: '120%' }
    // },
	[mediaQuery.short]: {
		question: { paddingTop: pxToEm(10) }
	},
	[mediaQuery.shorter]: {
		question: { paddingTop: pxToEm(10) }
	},
	[mediaQuery.shortest]: {
		question: { paddingTop: pxToEm(10) }
	}
};
